import { createSlice } from "@reduxjs/toolkit";

export const cartSlice = createSlice({
  name: "cart",
  initialState: {
    items: [],
  },
  reducers: {
    addItem: (state, action) => {
      const newItem = action.payload; 
      const existingItemIndex = state.items.findIndex(
        (item) => item.nft_id === newItem.nft_id
      );
      if (existingItemIndex === -1) {
        state.items.push(newItem);
      }
    },
    removeItem: (state, action) => {
      const itemIdToRemove = action.payload.nft_id;
      state.items = state.items.filter(
        (item) => item.nft_id !== itemIdToRemove
      );
    },
    clearCart: (state) => {
      state.items = [];
    },
  },
});

export const { addItem, removeItem, clearCart } = cartSlice.actions;

export const selectCartItems = (state) => state.cart.items;

export default cartSlice.reducer;
